import Excel, { AddWorksheetOptions } from 'exceljs'

enum ExcelOption {
    FileTypeMIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

const createWorkbook = (): Excel.Workbook => {
    const workbook = new Excel.Workbook()

    return workbook
}

const createWorksheet = ({
    workbook,
    options,
    sheetName = 'My Sheet',
}: {
    workbook: Excel.Workbook
    sheetName?: string
    options?: Partial<AddWorksheetOptions>
}): Excel.Worksheet => {
    const worksheet = workbook.addWorksheet(sheetName, options)
    return worksheet
}

const createFileDownload = ({
    workbook,
    fileName,
    resolve,
}: {
    workbook: Excel.Workbook
    fileName: string
    resolve?: any
}) => {
    return workbook.xlsx.writeBuffer().then((data: any) => {
        let blob = new Blob([data], { type: ExcelOption.FileTypeMIME })

        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')

        anchor.href = url
        anchor.download = fileName
        document.body.appendChild(anchor)

        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, fileName)
        } else {
            anchor.click()
        }

        document.body.removeChild(anchor)
        window.URL.revokeObjectURL(url)
        if (url) return url
    })
}

export const createFileDownloadWorker = (blob: any, fileName: string) => {
    const url = window.URL.createObjectURL(blob)

    const anchor = document.createElement('a')

    anchor.href = url
    anchor.download = fileName
    document.body.appendChild(anchor)

    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName)
    } else {
        anchor.click()
    }

    setTimeout(() => {
        document.body.removeChild(anchor)
        window.URL.revokeObjectURL(url)
    }, 100)
}

export default {
    createWorkbook,
    createWorksheet,
    createFileDownload,
    createFileDownloadWorker,
}
